import { getNameByFinancialCompanyCode, PAYMENT_METHOD_LABEL } from '@common/constants';

type Language = 'ko' | 'en' | 'ja';

import { PaymentMethod } from '../graphql/maximum-benefit_types.2';

export function convertCodeOrMethodToCardName(
  language: Language,
  financialCompanyCode: string | null,
  paymentMethod: PaymentMethod,
) {
  return financialCompanyCode
    ? getNameByFinancialCompanyCode(language, financialCompanyCode)
    : PAYMENT_METHOD_LABEL[paymentMethod as keyof typeof PaymentMethod][language];
}
